import { Message } from 'common/infrastructure/bus';
import { IEvent } from 'common/infrastructure/event.bus';
import { AssetCreatedEvent } from '@planitgeo/treeplotter-domain/lib/modules/asset-class/asset/domain/event/asset-created.event';
import loggerService, { LoggerLevel } from 'common/infrastructure/log';

export const processEvent = async (event: Message<IEvent<AssetCreatedEvent>>) => {
  loggerService.log(LoggerLevel.INFO, 'Asset created', event.data.payload);
};
